module.exports = "https://www.gc-pro.gnp.com.mx/0012f95c8f953e254c715e206f6834e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-cards.svg
// module id = 8120
// module chunks = 0